import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion"; // Importamo motion

const HomeReviews = () => {
  const reviews = [
    {
      id: 1,
      name: "Luka K.",
      rating: 5,
      review: "Hrana je izvrsna, osoblje ljubazno! Definitivno dolazimo opet.",
    },
    {
      id: 2,
      name: "Ana M.",
      rating: 4.5,
      review: "Odlični čevapi, malo se čekalo ali isplatilo se.",
    },
    {
      id: 3,
      name: "Marko P.",
      rating: 5,
      review: "Najbolja tortilja u gradu, preporuke svima!",
    },
  ];

  // Funkcija za iscrtavanje zvjezdica (ostaje ista)
  const renderStars = (rating) => {
    const stars = [];
    for (let i = 1; i <= 5; i++) {
      if (i <= rating) {
        stars.push(
          <span key={i} className="star filled">
            ★
          </span>,
        );
      } else if (i - 0.5 === rating) {
        stars.push(
          <span key={i} className="star half">
            ★
          </span>,
        );
      } else {
        stars.push(
          <span key={i} className="star">
            ☆
          </span>,
        );
      }
    }
    return stars;
  };

  // Varijante za animaciju
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2, // Kartice iskaču jedna po jedna
      },
    },
  };

  const cardVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
  };

  return (
    <section className="home-reviews">
      <motion.h2
        className="section-title"
        initial={{ opacity: 0, y: -20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
      >
        Što naši gosti kažu
      </motion.h2>

      <motion.div
        className="reviews-grid"
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.3 }}
      >
        {reviews.map((r) => (
          <motion.div
            key={r.id}
            className="reviews-card"
            variants={cardVariants}
            whileHover={{ scale: 1.03 }} // Lagano povećanje na hover
          >
            <div className="stars-container">{renderStars(r.rating)}</div>
            <p className="review-text">"{r.review}"</p>
            <h4 className="reviewer-name">- {r.name}</h4>
          </motion.div>
        ))}
      </motion.div>

      <Link className="more-review-btn" to="/">
        Ostale recenzije
      </Link>
    </section>
  );
};

export default HomeReviews;
